@if (conclusions) {
    <div class="d-flex flex-column">
        <div class="header">{{ 'controls.effDetailFinalConclusion.title' | transloco }}</div>
        <div class="content d-flex flex-row">
            @if (testerFinalConclusion) {
                <eff-final-conclusion-box
                    class="tester-conclusion"
                    [finalConclusion]="testerFinalConclusion"
                    [isEditMode]="false"
                ></eff-final-conclusion-box>
            }

            <div class="reviewer-conclusion">
                @if (effectivenessModel.reviewEnabled && reviewerFinalConclusion) {
                    <eff-final-conclusion-box
                        [finalConclusion]="reviewerFinalConclusion"
                        [isEditMode]="false"
                    ></eff-final-conclusion-box>
                }
                <div></div>
            </div>
        </div>
    </div>
}
